package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class TagDto(
    val id: String, // UUID
    val name: String,
    val color: String? = null,
    val createdAt: String,
    val updatedAt: String,
)

@Serializable
data class PostTagDto(
    val postId: String, // UUID
    val tagId: String, // UUID
    val createdAt: String,
)

@Serializable
data class TagWithCountDto(
    val tag: TagDto,
    val postCount: Int,
)

@Serializable
data class CreateTagRequest(
    val name: String,
    val color: String? = null,
)

@Serializable
data class UpdateTagRequest(
    val name: String? = null,
    val color: String? = null,
)
